import React, { memo } from 'react';
import { ChatProvider } from './ChatProvider';

export const withChatProvider = (Component) => {
  const WithChatProvider = memo(({ id, onChangeId, ...props }) => {
    return (
      <ChatProvider id={id} onChangeId={onChangeId}>
        <Component {...props} />
      </ChatProvider>
    );
  });

  WithChatProvider.displayName = `WithChatProvider(${Component.displayName || Component.name || 'Component'})`;

  return WithChatProvider;
};
